import {JetView} from "webix-jet"; // Importing JetView from webix-jet framework
import {devConfig, profile} from "config/config"; // Importing configuration settings

/**
 * Class representing the TableCurrencyTRMView.
 * @extends JetView
 */
export default class TableCurrencyTRMView extends JetView {
    /**
     * Configures the view layout.
     * @returns {Object} The layout configuration.
     */
    config() {
        const _ = this.app.getService("locale")._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        var vthis = this; // Reference to the current instance
        return {
            rows: [{
                id: "preloader", // Preloader ID
                cols: [
                    {
                        view: "datatable", // DataTable view
                        id: "datatable", // DataTable ID
                        css: "webix_header_border webix_data_border webix_footer_border", // CSS classes for styling
                        select: true, // Enable row selection
                        columns: [
                            {id: "SourceCurrency", header: _("Moneda Origen"), width: 100, sort: "string"}, // Source currency column
                            {id: "DestinationCurrency", header: _("Moneda Destino"), width: 100, sort: "string"}, // Destination currency column
                            {id: "ExchangeRate", header: _("Tasa de cambio (TRM)"), width: 250, sort: "string"}, // Exchange rate column
                            {
                                id: "rating", header: "Acciones", width: 100, height: 25, // Actions column
                                template: function (obj) {
                                    return "<span class='webix_icon wxi-close edit'></span><span class='webix_icon wxi-close torefuse prm-approvalLogsApprove'></span>"; // Action icons
                                }
                            },
                        ],
                        onClick: {
                            "edit": function (euv, id) { // Click event for edit icon
                                var item = this.getItem(id); // Get the clicked item
                                vthis.app.callEvent("openEdit", [item]); // Trigger openEdit event
                            },
                            "torefuse": function (euv, id) { // Click event for delete icon
                                var item = this.getItem(id); // Get the clicked item
                                vthis.app.callEvent("openDelete", [item]); // Trigger openDelete event
                            },
                        },
                        tooltip: true, // Enable tooltips
                        math: true, // Enable math operations
                        loadahead: devConfig.getDefaultDataFetch(), // Data fetch configuration
                        pager: "pagerA" // Pager ID
                    }
                ]
            }]
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The grid instance.
     */
    init(grid) {
        grid = $$('datatable'); // Get the DataTable instance
        var Partner = profile.PartnerSelected; // Get the selected partner
        const _ = this.app.getService("locale")._; // Localization service
        var url = devConfig.geturlApi() + "TRM/GetExchangeRate"; // API URL for fetching exchange rates
        var filter = ""; // Filter string
        var optionsTypes = []; // Options for types
        var popupAdd; // Popup for adding new entries
        var popUpEdit; // Popup for editing entries

        // Event listener for filtering data
        this.on(this.app, "currencyTRM:filter", filterData => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ""; // Initialize filter string
            for (var i = 0; i < object.length; i++) {
                if ((typeof object[i][1] !== "object") && (object[i][1] !== "")) { // Check for non-object filters
                    if (object[i][0] == "Datepicker") { // Handle date range filter
                        var date = object[i][1].split(" - ");
                        string1 = string1 + '&dateFrom=' + date[0];
                        string1 = string1 + '&dateTo=' + date[1];
                    } else {
                        if (object[i][0] != "Date") {
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters
                        } else {
                            if (object[i][0] == "Date") {
                                var date = object[i][1].replace(" 00:00:00", ""); // Format date
                                string1 = string1 + '&dateFrom=' + date;
                                string1 = string1 + '&dateTo=' + date;
                            }
                        }
                    }
                } else {
                    if ((typeof object[i][1] === "object")) { // Handle object filters
                        var object2 = Object.entries(object[i][1]);
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === "start") { // Start date filter
                                    var d = new Date(object2[j][1]);
                                    var dateFrom = "dateFrom=" + ((d.getFullYear())) + ":" + ("00" + (d.getMonth() + 1)).slice(-2) + ":" + ("00" + d.getDate()).slice(-2) + " " + ("00" + d.getHours()).slice(-2) + ":" + ("00" + d.getMinutes()).slice(-2) + ":" + ("00" + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom;
                                } else {
                                    if (object2[j][0] === "end") { // End date filter
                                        var d = new Date(object2[j][1]);
                                        var dateTo = "dateTo=" + ((d.getFullYear())) + ":" + ("00" + (d.getMonth() + 1)).slice(-2) + ":" + ("00" + d.getDate()).slice(-2) + " " + ("00" + d.getHours()).slice(-2) + ":" + ("00" + d.getMinutes()).slice(-2) + ":" + ("00" + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo;
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.clearAll(); // Clear the grid data
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1, function () {
                grid.filter(function (obj) { // Filter out inactive items
                    return obj.Status !== "I";
                });
            });
            filter = string1; // Update filter string
        });

        // Event listener for adding new entries
        this.on(this.app, "exchangeRateTRM:button", item => {
            popupAdd.show(); // Show the add popup
            $$("addform").clearValidation(); // Clear validation on the form
        });

        // Popup configuration for adding new entries
        popupAdd = webix.ui({
            view: "window", // Window view
            id: "AddAdjustments", // Popup ID
            height: 700, // Popup height
            head: {
                view: "toolbar", // Toolbar for the popup
                cols: [
                    {view: "label", label: _("Crear TRM"), align: "center"}, // Title label
                    {view: "icon", icon: "wxi-close", click: function () { // Close button
                            this.getTopParentView().hide(); // Hide the popup
                        }}
                ]
            },
            position: "center", // Center the popup
            modal: true, // Make the popup modal
            body: {
                view: "form", id: "addform", elements: [ // Form for adding new entries
                    {view: "richselect", label: _("Moneda Origen:"), localId: "AddSourceCurrency:combo",
                        id: "AddSourceCurrency", name: "SourceCurrency", labelWidth: 150, labelPosition: "top", required: true}, // Source currency field
                    {view: "richselect", label: _("Moneda Destino:"), localId: "AddDestinationCurrency:combo",
                        id: "AddDestinationCurrency", name: "DestinationCurrency", labelWidth: 150, labelPosition: "top", required: true}, // Destination currency field
                    {view: "text", label: _("Tasa de cambio:"), name: "ExchangeRate", type: "text", labelWidth: 150, labelPosition: "top", required: true}, // Exchange rate field
                    {
                        cols: [
                            {
                                view: "button", value: _("Cancelar"), click: function () { // Cancel button
                                    this.getTopParentView().hide(); // Hide the popup
                                    $$('addform').setValues($$('addform').getCleanValues()); // Reset form values
                                }
                            },
                            {
                                view: "button", type: "form", class: "approve", value: _("Agregar conversión"), height: 45, click: function ($e) { // Add conversion button
                                    var values = $$("addform").getValues(); // Get form values
                                    var Partner = profile.PartnerSelected; // Get the selected partner
                                    if (!$$("addform").validate()) { // Validate form
                                        webix.message({
                                            title: _("¡Error!"),
                                            type: "alert-error",
                                            text: _("Completa los campos...") // Error message for incomplete fields
                                        });
                                        return;
                                    }
                                    if (values.SourceCurrency === values.DestinationCurrency) { // Check if currencies are the same
                                        webix.message({
                                            title: _("¡Error!"),
                                            type: "alert-error",
                                            text: _("La moneda de origen y destino no pueden ser iguales.") // Error message for same currencies
                                        });
                                        return;
                                    }
                                    if (isNaN(values.ExchangeRate) || values.ExchangeRate.trim() === "" || /[^\d.]/.test(values.ExchangeRate)) { // Validate exchange rate
                                        webix.message({
                                            title: _("¡Error!"),
                                            type: "alert-error",
                                            text: _("El valor debe ser numérico y no debe tener caracteres especiales.") // Error message for invalid exchange rate
                                        });
                                        return;
                                    }
                                    if (parseFloat(values.ExchangeRate) <= 0) { // Check if exchange rate is greater than 0
                                        webix.message({
                                            title: _("¡Error!"),
                                            type: "alert-error",
                                            text: _("El valor debe ser mayor a 0.") // Error message for non-positive exchange rate
                                        });
                                        return;
                                    }
                                    if (!/^\d+(\.\d{1,4})?$/.test(values.ExchangeRate)) { // Validate decimal places
                                        webix.message({
                                            title: _("¡Error!"),
                                            type: "alert-error",
                                            text: _("El valor debe tener un máximo de 4 decimales.") // Error message for too many decimal places
                                        });
                                        return;
                                    }
                                    webix.ajax().headers({
                                        "Content-type": "application/json" // Set content type for AJAX request
                                    }).post(devConfig.geturlApi() + "TRM/SaveExchangeRate", '{"Partner":"' + Partner + '","SourceCurrency":"' + values.SourceCurrency + '", "DestinationCurrency":"' + values.DestinationCurrency + '", "ExchangeRate":"' + values.ExchangeRate + '", "Status":"A"}', {
                                        error: function (text, data, XmlHttpRequest) {
                                            webix.message("Error! "); // Error message for AJAX request failure
                                        },
                                        success: function (text, data, XmlHttpRequest) {
                                            var json = JSON.parse(text); // Parse response JSON
                                            if (json.HasError) { // Check for errors in response
                                                if (json.CodeError != 110012) {
                                                    webix.message({
                                                        title: _("¡Error!"),
                                                        type: "alert-error",
                                                        text: json.AlertMessage // Display error message from response
                                                    });
                                                }
                                            } else {
                                                webix.message("Conversion Registrada Exitosamente"); // Success message
                                                grid.clearAll(); // Clear grid data
                                                grid.load(url + '?start=0&count=' + grid.data.$pagesize + filter); // Reload grid data
                                            }
                                        }
                                    });
                                    $$('addform').setValues($$('addform').getCleanValues()); // Reset form values
                                    this.getTopParentView().hide(); // Hide the popup
                                }
                            }
                        ]
                    }
                ],
                elementsConfig: {
                    on: {
                        onChange: function () {
                            this.validate(); // Validate form on change
                        }
                    }
                },
                rules: {
                    SourceCurrency: webix.rules.isNotEmpty, // Validation rule for source currency
                    DestinationCurrency: webix.rules.isNotEmpty // Validation rule for destination currency
                }
            }
        });

        // Event listener for editing entries
        this.on(this.app, 'openEdit', item => {
            webix.ui({
                view: "window", // Window view
                id: "editCurrencyTRM", // Popup ID
                height: 550, // Popup height
                head: {
                    view: "toolbar", // Toolbar for the popup
                    cols: [
                        {view: "label", label: _("Editar TRM")}, // Title label
                        {view: "icon", icon: "wxi-close", click: function () { // Close button
                                this.getTopParentView().hide(); // Hide the popup
                            }}
                    ]
                },
                position: "center", // Center the popup
                modal: true, // Make the popup modal
                body: {
                    view: "form", id: "editform", // Form for editing entries
                    elements: [
                        {
                            view: "text",
                            name: "SourceCurrency",
                            minWidth: 150,
                            label: _("Moneda Origen"), // Source currency label
                            labelPosition: "top",
                            readonly: true, // Make field read-only
                            options: []
                        },
                        {
                            view: "text", name: "DestinationCurrency", minWidth: 150,
                            label: _("Moneda Destino"), labelPosition: "top", readonly: true, // Destination currency label
                            options: []
                        },
                        {
                            view: "text", name: "ExchangeRate", minWidth: 150,
                            label: _("Tasa de cambio"), labelPosition: "top", // Exchange rate label
                            placeholder: _("Tasa de cambio"), type: "number" // Placeholder for exchange rate
                        },
                        {
                            cols: [
                                {
                                    view: "button", value: _("Cancelar"), click: function () { // Cancel button
                                        this.getTopParentView().hide(); // Hide the popup
                                    }
                                },
                                {
                                    view: "button", type: "form", value: _("Guardar Cambios"), height: 45, click: function ($e) { // Save changes button
                                        var values = $$("editform").getValues(); // Get form values
                                        var Partner = profile.PartnerSelected; // Get the selected partner
                                        console.log(item); // Log the item being edited
                                        webix.confirm({
                                            type: "confirm", // Confirmation dialog
                                            text: _("¿Desea guardar los cambios realizados en las tasas de cambio?"),
                                            ok: _("Confirmar"),
                                            cancel: _("Cancelar"),
                                            width: (screen.width < 500) ? 300 : 500,
                                            height: (screen.width < 500) ? 200 : 0,
                                            callback: function (action) {
                                                if (action === true) { // If confirmed
                                                    if (!$$("editform").validate()) { // Validate form
                                                        webix.message({
                                                            title: _("¡Error!"),
                                                            type: "alert-error",
                                                            text: _("Completa los campos...") // Error message for incomplete fields
                                                        });
                                                        return;
                                                    }
                                                    if (isNaN(values.ExchangeRate) || values.ExchangeRate.trim() === "") { // Validate exchange rate
                                                        webix.message({
                                                            title: _("¡Error!"),
                                                            type: "alert-error",
                                                            text: _("El valor debe ser numérico.") // Error message for invalid exchange rate
                                                        });
                                                        return;
                                                    }
                                                    if (parseFloat(values.ExchangeRate) <= 0) { // Check if exchange rate is greater than 0
                                                        webix.message({
                                                            title: _("¡Error!"),
                                                            type: "alert-error",
                                                            text: _("El valor debe ser mayor a 0.") // Error message for non-positive exchange rate
                                                        });
                                                        return;
                                                    }
                                                    if (!/^\d+(\.\d{1,4})?$/.test(values.ExchangeRate)) { // Validate decimal places
                                                        webix.message({
                                                            title: _("¡Error!"),
                                                            type: "alert-error",
                                                            text: _("El valor debe tener un máximo de 4 decimales.") // Error message for too many decimal places
                                                        });
                                                        return;
                                                    }
                                                    webix.ajax().headers({
                                                        "Content-type": "application/json" // Set content type for AJAX request
                                                    }).post(devConfig.geturlApi() + "/TRM/SaveExchangeRate", '{"Partner":"' + Partner + '", "Id":"' + item.Id + '","SourceCurrency":"' + values.SourceCurrency + '", "DestinationCurrency":"' + values.DestinationCurrency + '", "ExchangeRate":"' + values.ExchangeRate + '", "Status":"A"}', {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            webix.message("Error! "); // Error message for AJAX request failure
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            webix.message("Los cambios han sido guardados exitosamente."); // Success message
                                                            grid.clearAll(); // Clear grid data
                                                            grid.load(url + '?start=0&count=' + grid.data.$pagesize + filter); // Reload grid data
                                                            if ($$('editCurrencyTRM')) {
                                                                $$('editCurrencyTRM').hide(); // Hide the popup
                                                            }
                                                            this.getTopParentView().hide(); // Hide the popup
                                                        }
                                                    });
                                                } else {
                                                    webix.message("No se realizaron cambios."); // Message for no changes
                                                }
                                            }
                                        });
                                    }
                                }
                            ]
                        }
                    ]
                }
            }).show(); // Show the edit popup
            $$("editform").parse(item); // Populate form with item data
        });

        // Event listener for deleting entries
        this.on(this.app, 'openDelete', item => {
            webix.confirm({
                type: "confirm-warning", // Warning confirmation dialog
                text: _("Advertencia!") + "<br/>" + _("¿Desea eliminar esta conversión de moneda?"),
                ok: _("Confirmar"),
                cancel: _("Cancelar"),
                callback: function (action) {
                    if (action === true) { // If confirmed
                        webix.ajax().headers({
                            "Content-type": "application/json" // Set content type for AJAX request
                        }).post(devConfig.geturlApi() + "/TRM/SaveExchangeRate", '{"Partner":"' + Partner + '", "Id":"' + item.Id + '","SourceCurrency":"' + item.SourceCurrency + '", "DestinationCurrency":"' + item.DestinationCurrency + '", "ExchangeRate":"' + item.ExchangeRate + '", "Status":"I"}', {
                            error: function (text, data, XmlHttpRequest) {
                                webix.message(_("Error! ")); // Error message for AJAX request failure
                            },
                            success: function (text, data, XmlHttpRequest) {
                                var json = JSON.parse(text); // Parse response JSON
                                if (json.HasError) { // Check for errors in response
                                    webix.message({title: _("¡Error!"), type: "alert-error", text: _("Ocurrio un error, comuniquese con soporte")}); // Display error message
                                } else {
                                    webix.message('Conversion Eliminada'); // Success message
                                    item.StateId = 'I'; // Mark item as inactive
                                    grid.clearAll(); // Clear grid data
                                    grid.load(url + '?start=0&count=' + grid.data.$pagesize + filter); // Reload grid data
                                }
                            }
                        });
                    }
                }
            });
        });
    }
}

// FILE DOCUMENTED
